import { useHandler } from "@chatbotgang/etude/react/useHandler";
import { safePromise } from "@chatbotgang/etude/safe/safePromise";
import { SERVER_REGION } from "@polifonia/env";
import { useStatsigUser } from "@statsig/react-bindings";
import { useEffect } from "react";

import { rootQueriesContext } from "@/queriesContext/rootQueriesContext";

/**
 * Updates the Statsig user with the current user's organization information.
 */
const BindStatsigUser: React.FC = () => {
  const { updateUserAsync: originalUpdateUserAsync } = useStatsigUser();
  const { me } = rootQueriesContext.useData();
  const updateUserAsync = useHandler(originalUpdateUserAsync);

  useEffect(
    function bindStatsigUser() {
      (async () => {
        await safePromise(() =>
          updateUserAsync({
            custom: {
              org_name: me.organization.name,
              release_tier: me.organization.releaseTier,
              region: SERVER_REGION,
              timezone: me.organization.timezone ?? "",
            },
            customIDs: {
              org_uuid: me.organization.uuid,
            },
          }),
        );
      })();
    },
    [
      me.organization.name,
      me.organization.uuid,
      me.organization.releaseTier,
      me.organization.timezone,
      updateUserAsync,
    ],
  );

  return null;
};

export { BindStatsigUser };
